import { useTranslation } from 'react-i18next';
import iconFirmar from '../../assets/icon-firmar.svg';
import { ComponentAlerts } from './ComponentAlerts';
import { useEffect, useState } from 'react';
import { getFile } from '../../utils/indexedDB';
import PdfViewer from './viewer/ViewerPdf';

export const ComponentDocument = ({ fileName }) => {
    const { t } = useTranslation();
    const [pdfBlobUrl, setPdfBlobUrl] = useState('');
    const [fName, setFName] = useState(fileName || localStorage.getItem('fileName'));
    useEffect(() => {
        if (fName) {
            getFile(fName).then(storedDocument => {
                if (storedDocument) {
                    const byteCharacters = atob(storedDocument);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: 'application/pdf' });
                    const blobUrl = URL.createObjectURL(blob);
                    setPdfBlobUrl(blobUrl);
                }
            });
        }
    }, [fileName]);

    return (
        <div className="component-documento">
            {/* Alerts */}
            <ComponentAlerts />

            {/* Titulo de seccion */}
            <h1 className="page-title">
                <img src={iconFirmar} className="img-fluid" alt={t('componentDocument.iconAlt')} />
                {t('componentDocument.title')}
            </h1>

            {/* iframe */}
            <div className="container-file">
                {/* <iframe className="pdf-file" src={pdfBlobUrl} frameBorder="0" title={t('componentDocument.iframeTitle')}></iframe> */}
                <PdfViewer blobUrl={pdfBlobUrl} fileName={t('componentDocument.iframeTitle')}/>
            </div>
        </div>
    );
};
